// extracted by mini-css-extract-plugin
module.exports = {"IframeViscom":"IframeViscom_IframeViscom__ItucV"};